import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { ViewSpaceExternalCollaboratorsDialogQuery } from './graphql/ViewSpaceExternalCollaboratorsDialogQuery.graphql.ts';

export function preloadSpaceGuestList(spaceKey: string) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ViewSpaceExternalCollaboratorsDialogQuery,
		variables: {
			spaceKey,
		},
	});
}
